import { PageDocument, StringConstants } from "src/constant/stringConstants";
import { Col, Row, Typography } from "antd";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import TranslationKey from "src/i18n/translation";
const { Text } = Typography;

export default function ArtistPrivacyPolicy() {
    useEffect(() => {
        document.title = `Privacy Policy - ${PageDocument.Title}`;
    }, []);

  return (
    <div className="container py-5 banner-margin-t-50">
      <Row className="d-flex justify-content-center">
        <Col span={16}>
          <Title className="text-primary" level={3}>
            {TranslationKey('privacyPolicyArtist.privacyPolicyFotSiteUse')}
          </Title>
          <p>{TranslationKey('privacyPolicyArtist.thisPrivacyPolicyHereinafter')} </p>
          <Title className="text-primary" level={3}>
            {TranslationKey('privacyPolicyArtist.aliveUnitedDataProtectionNoticeForWebsiteUsers.title')}
          </Title>
          <p>{TranslationKey('privacyPolicyArtist.aliveUnitedDataProtectionNoticeForWebsiteUsers.thisAliveUnitedData')} </p>
          <p>{TranslationKey('privacyPolicyArtist.aliveUnitedDataProtectionNoticeForWebsiteUsers.inTheOperations')} </p>
          <p>{TranslationKey('privacyPolicyArtist.aliveUnitedDataProtectionNoticeForWebsiteUsers.theDataProtectionNotice')}</p>
          <p>{TranslationKey('privacyPolicyArtist.aliveUnitedDataProtectionNoticeForWebsiteUsers.pleaseReadThisData')}</p>
          <p>{TranslationKey('privacyPolicyArtist.aliveUnitedDataProtectionNoticeForWebsiteUsers.thisDataProtectionNotice')} </p>
          <Title className="text-primary" level={3}>
          {TranslationKey('privacyPolicyArtist.whatIsPersonalData')}
          </Title>
          <p>{TranslationKey('privacyPolicyArtist.personalDataMeansAnyInformation')}</p>
          <Title className="text-primary" level={3}>
          {TranslationKey('privacyPolicyArtist.yourPersonalDataThatWeMayCollectProcessAndOrDisclose.title')}
          </Title>
          <p>{TranslationKey('privacyPolicyArtist.yourPersonalDataThatWeMayCollectProcessAndOrDisclose.weMayCollect')}</p>
          <p>{TranslationKey('privacyPolicyArtist.yourPersonalDataThatWeMayCollectProcessAndOrDisclose.weAlsoReceive')}</p>
          <p>{TranslationKey('privacyPolicyArtist.yourPersonalDataThatWeMayCollectProcessAndOrDisclose.weMayCollectProcessCategories')}</p>
          <Title className="text-primary" level={3}>
          {TranslationKey('privacyPolicyArtist.personalInformation.title')}
          </Title>
          <p>{TranslationKey('privacyPolicyArtist.personalInformation.thePersonalDataInThis')}</p>
          <p>{TranslationKey('privacyPolicyArtist.personalInformation.asOurArtists')}</p>
          <Title className="text-primary" level={3}>
          {TranslationKey('privacyPolicyArtist.contactInformation.title')}
          </Title>
          <p>{TranslationKey('privacyPolicyArtist.contactInformation.thePersonalData')}</p>
          <Title className="text-primary" level={3}>
          {TranslationKey('privacyPolicyArtist.financialAndTransactionalInformation.title')}
          </Title>
          <p> {TranslationKey('privacyPolicyArtist.financialAndTransactionalInformation.thePersonalData')}</p>
          <p> {TranslationKey('privacyPolicyArtist.financialAndTransactionalInformation.asOurArtists')} </p>
          <Title className="text-primary" level={3}>
          {TranslationKey('privacyPolicyArtist.uniqueIdentifierInformationAndOnlineAndTechnicalInformation.title')}
          </Title>
          <p>{TranslationKey('privacyPolicyArtist.uniqueIdentifierInformationAndOnlineAndTechnicalInformation.thePersonalData')}</p>
          <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.demographicInformationAndPreferences.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.demographicInformationAndPreferences.thePersonalData')}</p>
      <p>{TranslationKey('privacyPolicyArtist.demographicInformationAndPreferences.asTheData')}</p>
      
      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.personalDataInArtsAndContents.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.personalDataInArtsAndContents.thePersonalData')}</p>
      <p>{TranslationKey('privacyPolicyArtist.personalDataInArtsAndContents.leaseAlsoRefer')}</p>
      
      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.biometricInformation.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.biometricInformation.thePersonalData')}</p>
      <p>{TranslationKey('privacyPolicyArtist.biometricInformation.asTheData')}</p>
      
      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.personalDataOfMinors.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.personalDataOfMinors.forThePersonalData')}</p>
      
      <Text className="text-primary" strong>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.title')}</Text>
      <p>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.weCollectYourPersonalData')}</p>
      <dl>
        <dt>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.title')}</dt>
        <dd className="dd-indent">
        <ul>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.yourAccount')}</li>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.submission')}</li>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.downloading')}</li>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.uploading')}</li>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.visiting')}</li>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.viewing')}</li>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.using')}</li>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.subscription')}</li>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.filling')}</li>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.other')}</li>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.yourPurchase')}</li>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.yourLogIns')}</li>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.youEmails')}</li>
            <li>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.1.yourBrowser')}</li>
          </ul>
        </dd>
        <dt>{TranslationKey('privacyPolicyArtist.howDoWeCollectYourPersonalData.2')}</dt>
      </dl>
      <Text className="text-primary" strong>
        {TranslationKey('privacyPolicyArtist.OurObjectivesOfPersonalDataCollectionProcessingAndDisclosure.title')}
      </Text>
      <dl>
        <dt>
          {TranslationKey('privacyPolicyArtist.OurObjectivesOfPersonalDataCollectionProcessingAndDisclosure.weMayCollect')}
        </dt>
        <dd className="dd-indent">
          <dt>1. {TranslationKey('privacyPolicyArtist.OurObjectivesOfPersonalDataCollectionProcessingAndDisclosure.1')}</dt>
          <dd className="dd-indent">
            <p>{TranslationKey('privacyPolicyArtist.OurObjectivesOfPersonalDataCollectionProcessingAndDisclosure.1desc1')}</p>
            <p>{TranslationKey('privacyPolicyArtist.OurObjectivesOfPersonalDataCollectionProcessingAndDisclosure.1desc2')}</p>
          </dd>
          <dt>2. {TranslationKey('privacyPolicyArtist.OurObjectivesOfPersonalDataCollectionProcessingAndDisclosure.2')}</dt>
          <dd className="dd-indent">
            <p>{TranslationKey('privacyPolicyArtist.OurObjectivesOfPersonalDataCollectionProcessingAndDisclosure.2desc')}</p>
          </dd>
          <dt>3. {TranslationKey('privacyPolicyArtist.OurObjectivesOfPersonalDataCollectionProcessingAndDisclosure.3')}</dt>
          <dd className="dd-indent">
            <p>{TranslationKey('privacyPolicyArtist.OurObjectivesOfPersonalDataCollectionProcessingAndDisclosure.3desc')}</p>
          </dd>
          <dt>4. {TranslationKey('privacyPolicyArtist.OurObjectivesOfPersonalDataCollectionProcessingAndDisclosure.4')}</dt>
          <dd className="dd-indent">
            <p>{TranslationKey('privacyPolicyArtist.OurObjectivesOfPersonalDataCollectionProcessingAndDisclosure.4desc1')}</p>
            <p>{TranslationKey('privacyPolicyArtist.OurObjectivesOfPersonalDataCollectionProcessingAndDisclosure.4desc2')}</p>
          </dd>
        </dd>
      </dl>

      <Text className="text-primary" strong>
        {TranslationKey('privacyPolicyArtist.ourPersonalDataProcessingSharingAndTransfer.title')}
      </Text>
      <p>{TranslationKey('privacyPolicyArtist.ourPersonalDataProcessingSharingAndTransfer.yourPersonalData')}</p>
      <p>{TranslationKey('privacyPolicyArtist.ourPersonalDataProcessingSharingAndTransfer.weMayShare')}</p>
      <p>{TranslationKey('privacyPolicyArtist.ourPersonalDataProcessingSharingAndTransfer.weMayAs')}</p>

      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.marketingAndAdvertisement.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.marketingAndAdvertisement.withYourConsent')}</p>

      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.dataStorageAndDataRetention.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.dataStorageAndDataRetention.weMayStore')}</p>
      <ol>
        <li>{TranslationKey('privacyPolicyArtist.dataStorageAndDataRetention.1')}</li>
        <li>{TranslationKey('privacyPolicyArtist.dataStorageAndDataRetention.2')}</li>
        <li>{TranslationKey('privacyPolicyArtist.dataStorageAndDataRetention.3')}</li>
      </ol>

      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.DataRetentionPeriodAndLegalBasisOfCollectionAndProcessing.title')}
      </Title>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th style={{ width: '10%' }}>No.</th>
              <th style={{ width: '30%' }}>Type of Personal Data</th>
              <th style={{ width: '30%' }}>Legal Basis</th>
              <th style={{ width: '30%' }}>Retention Period</th>
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3, 4, 5, 6, 7].map((num) => (
              <tr key={num}>
                <td>{num}.</td>
                <td>{TranslationKey(`privacyPolicyArtist.DataRetentionPeriodAndLegalBasisOfCollectionAndProcessing.columnTypeOfPersonalData.${num}`)}</td>
                <td>{TranslationKey(`privacyPolicyArtist.DataRetentionPeriodAndLegalBasisOfCollectionAndProcessing.columnLegalBasis.${num}`)}</td>
                <td>{TranslationKey(`privacyPolicyArtist.DataRetentionPeriodAndLegalBasisOfCollectionAndProcessing.columnRetention Period.${num}`)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.yourRightsAndChoices.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.yourRightsAndChoices.toEnsure')}</p>
      <ol>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
          <li key={num}>{TranslationKey(`privacyPolicyArtist.yourRightsAndChoices.${num}`)}</li>
        ))}
      </ol>
      <p>{TranslationKey('privacyPolicyArtist.yourRightsAndChoices.youCanMakeARequest')}</p>
      <p>{TranslationKey('privacyPolicyArtist.yourRightsAndChoices.forYourRight')}</p>
      <p>{TranslationKey('privacyPolicyArtist.yourRightsAndChoices.NoteUnlessTheRequestMadeToUs')}</p>

      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.whatAreCookies.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.whatAreCookies.cookies')}</p>
      <p>{TranslationKey('privacyPolicyArtist.whatAreCookies.ifYouWish')}</p>
      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.howDoWeUseCookies.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.weUseCookiesForManyPurposes.title')}</p>
      <ul>
        <li>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.weUseCookiesForManyPurposes.toIncrease')}</li>
        <li>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.weUseCookiesForManyPurposes.toCollect')}</li>
        <li>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.weUseCookiesForManyPurposes.toResearchAnIndividual')}</li>
        <li>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.weUseCookiesForManyPurposes.toResearchYourBehavioral')}</li>
        <li>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.weUseCookiesForManyPurposes.toServe')}</li>
        <li>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.weUseCookiesForManyPurposes.toHelp')}</li>
        <li>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.weUseCookiesForManyPurposes.toRemember')}</li>
      </ul>
      <p>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.theTypesOfCookies.title')}</p>
      <ul>
        <li>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.theTypesOfCookies.functionality')}</li>
        <li>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.theTypesOfCookies.advertising')}</li>
        <li>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.theTypesOfCookies.strictly')}</li>
        <li>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.theTypesOfCookies.performance')}</li>
        <li>{TranslationKey('privacyPolicyArtist.howDoWeUseCookies.theTypesOfCookies.thirdParty')}</li>
      </ul>

      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.cookiesSetting.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.cookiesSetting.youCanDisable')}</p>

      <Text className="text-primary" strong>{TranslationKey('privacyPolicyArtist.forSafariUsers.title')}</Text>
      <ol>
        <li>{TranslationKey('privacyPolicyArtist.forSafariUsers.1')}</li>
        <li>
          {TranslationKey('privacyPolicyArtist.forSafariUsers.2.title')}
          <ul>
            <li>{TranslationKey('privacyPolicyArtist.forSafariUsers.2.enablingPrevent')}</li>
            <li>{TranslationKey('privacyPolicyArtist.forSafariUsers.2.enablingBlock')}</li>
            <li>{TranslationKey('privacyPolicyArtist.forSafariUsers.2.chooseTheManage')}</li>
          </ul>
        </li>
      </ol>

      <Text className="text-primary" strong>{TranslationKey('privacyPolicyArtist.forGoogleChromeUsers.title')}</Text>
      <ul>
        <li>{TranslationKey('privacyPolicyArtist.forGoogleChromeUsers.open')}</li>
        <li>{TranslationKey('privacyPolicyArtist.forGoogleChromeUsers.clickAdvanced')}</li>
        <li>{TranslationKey('privacyPolicyArtist.forGoogleChromeUsers.under')}</li>
        <li>{TranslationKey('privacyPolicyArtist.forGoogleChromeUsers.clickCookies')}</li>
        <li>{TranslationKey('privacyPolicyArtist.forGoogleChromeUsers.ifYouWish')}</li>
      </ul>

      <Text className="text-primary" strong>{TranslationKey('privacyPolicyArtist.forInternetExplorerUsers.title')}</Text>
      <ul>
        <li>{TranslationKey('privacyPolicyArtist.forInternetExplorerUsers.open')}</li>
        <li>{TranslationKey('privacyPolicyArtist.forInternetExplorerUsers.choose')}</li>
        <li>{TranslationKey('privacyPolicyArtist.forInternetExplorerUsers.click')}</li>
        <li>{TranslationKey('privacyPolicyArtist.forInternetExplorerUsers.under')}</li>
      </ul>

      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.dataProtectionPoliciesOfThirdPartyWebsites.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.dataProtectionPoliciesOfThirdPartyWebsites.thisDataProtection')}</p>

      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.effectOfNoticeAndChangesToNotice.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.effectOfNoticeAndChangesToNotice.thisDataProtection')}</p>
      <p>{TranslationKey('privacyPolicyArtist.effectOfNoticeAndChangesToNotice.weMayRevise')}</p>

      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.dataController.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.dataController.nameShots')}</p>
      <p>{TranslationKey('privacyPolicyArtist.dataController.soi')}</p>
      <p>{TranslationKey('privacyPolicyArtist.dataController.khlong')}</p>
      <p>{TranslationKey('privacyPolicyArtist.dataController.emailAddress')}</p>
      <a href={TranslationKey('privacyPolicyArtist.dataController.website')}>{TranslationKey('privacyPolicyArtist.dataController.website')}</a>

      <Title className="text-primary" level={3}>
        {TranslationKey('privacyPolicyArtist.dataProtectionOfficer.title')}
      </Title>
      <p>{TranslationKey('privacyPolicyArtist.dataProtectionOfficer.name')}</p>
       <dt>
       <Title className="text-primary" level={3}>
            {TranslationKey('effectiveDate.title')}
            </Title>
          </dt>
          <dd className="dd-indent">
          {TranslationKey('effectiveDate.date')}
          </dd>
          <dt>
            <Title className="text-primary" level={3}>
            {TranslationKey('lastUpdatedDate.title')}
            </Title>
          </dt>
          <dd className="dd-indent">
          {TranslationKey('lastUpdatedDate.date')}
          </dd>
          <Title className="text-primary" level={3}>
          {TranslationKey('hContactUs')}
          </Title>
          <Text className="text-primary" strong>{TranslationKey('privacyPolicyArtist.dataController.title')}</Text>
          <p>{TranslationKey('privacyPolicyArtist.dataController.nameShots')}</p>
          <p>{TranslationKey('privacyPolicyArtist.dataController.soi')}</p>
          <p>{TranslationKey('privacyPolicyArtist.dataController.khlong')} </p>
          <p>{TranslationKey('privacyPolicyArtist.dataController.emailAddress')} support@aliveunited.com</p>
          <p>{TranslationKey('privacyPolicyArtist.dataController.website')}: <a href={`${process.env.REACT_APP_REDIRECT_PATH ?? StringConstants.EMPTY}`}>aliveunited.com</a></p>
          <Text className="text-primary" strong>{TranslationKey('privacyPolicyArtist.dataController.title')}</Text>
          <p>{TranslationKey('privacyPolicyArtist.dataController.name')}</p>
          <p>{TranslationKey('privacyPolicyArtist.dataProtectionOfficer.emailAddress')}: legal@aliveunited.com </p>
        </Col>
        
      </Row>
    </div>
  );
}
